import React, { FC } from 'react'
import { Progress, ProgressProps } from '@chakra-ui/core'

export interface Props extends ProgressProps {
  value: number
}

export const ProgressBar: FC<Props> = ({ value, ...props }) => {
  return (
    <Progress value={value} height="4px" color="secondary" backgroundColor="gray.200" borderRadius="2px" {...props} />
  )
}
